import { ToastAnimateFrom, ToastContent, ToastPosition } from '@bechtel/gds';
import { FC, useState } from 'react';
import { HeaderLogo } from '~/components/header-logo';
import { PageHeader } from '~/components/page-header';
import { ProjectAdminList } from './list/project-admin-list';
import { ProjectAdminRoutes } from './route';
import { ContentStyled } from './styled';

const ProjectAdmin: FC = () => {
  const [isListCollapsed, setIsListCollapsed] = useState(false);
  const handleToggleCollapse = () => {
    setIsListCollapsed((state) => !state);
  };

  return (
    <>
      <PageHeader>
        <HeaderLogo></HeaderLogo>
      </PageHeader>
      <ContentStyled>
        <ProjectAdminList isListCollapsed={isListCollapsed} onToggleCollapse={handleToggleCollapse} />
        <ProjectAdminRoutes isListCollapsed={isListCollapsed} />
        <ToastContent position={ToastPosition.MIDDLE} animateFrom={ToastAnimateFrom.BOTTOM} />
      </ContentStyled>
    </>
  );
};

export default ProjectAdmin;
